import { createAction } from 'redux-actions';

export const requestGetProjectCategoriesAction = createAction('REQUEST/GET_PROJECT_CATEGORIES');

export const cancelProjectAction = createAction('REQUEST/CANCEL_PROJECT_ACTION');
